/**
 * Polski plural dla rzeczowników rodzaju nijakiego typu „zadanie":
 *   1 → zadanie
 *   2-4 → zadania (poza 12-14)
 *   reszta → zadań
 *
 * Reguła odmiany przez liczbę w polskim — branchy `last % 10` z guardami
 * dla -nastek. Identyczna logika jak w innych pluralach (np. „dziecko/dzieci"),
 * ale tu trzymamy konkretne formy "zadanie/zadania/zadań".
 */
export function pluralizeZadania(n: number): string {
  if (n === 1) return "zadanie";
  const lastTwo = n % 100;
  const last = n % 10;
  if (lastTwo >= 12 && lastTwo <= 14) return "zadań";
  if (last >= 2 && last <= 4) return "zadania";
  return "zadań";
}
